/** До 10 цифр национальной части (без ведущей 7). */
function nationalDigits(raw: string): string {
  let d = raw.replace(/\D/g, "");
  if (d.startsWith("8")) {
    d = "7" + d.slice(1);
  }
  if (d.startsWith("7")) {
    d = d.slice(1);
  }
  return d.slice(0, 10);
}

/** Маска ввода +7 XXX XXX-XX-XX без сторонних библиотек (совместимо с react-hook-form). */
export function formatRuTelInput(raw: string): string {
  const d = nationalDigits(raw);
  if (d.length === 0) {
    return "";
  }
  let out = "+7";
  if (d.length <= 3) {
    out += " " + d;
  } else if (d.length <= 6) {
    out += " " + d.slice(0, 3) + " " + d.slice(3);
  } else if (d.length <= 8) {
    out += " " + d.slice(0, 3) + " " + d.slice(3, 6) + "-" + d.slice(6);
  } else {
    out +=
      " " +
      d.slice(0, 3) +
      " " +
      d.slice(3, 6) +
      "-" +
      d.slice(6, 8) +
      "-" +
      d.slice(8, 10);
  }
  return out;
}
